import {hasValue} from '../../../../common/utils/utils';
import { cloneDeep } from 'lodash';
export const SET_FILTERS = 'SET_FILTERS';
export const REFRESH_FILTERS = 'REFRESH_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_MENU_FILTERS = 'SET_MENU_FILTERS';

export const initialstate = {};

export default function projectFinancialFilterReducer(
	state = initialstate,
	action
) {
	switch (action.type) {
		case SET_FILTERS: {
			if (action.filter) {
				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						[action.filter.name]: {
							...action.filter,
							value: action.value
						}
					}
				};

				if (!hasValue(result[action.key][action.filter.name].value)) {
					delete result[action.key][action.filter.name].value;
				}

				return result;
			} else {
				return {
					...state,
					[action.key]: action.value
				};
			}
		}

		case REFRESH_FILTERS: {
			return {
				...state,
				[action.filterKey]: action.filters
			};
		}

		case CLEAR_FILTERS: {
			return {
				...state,
				[action.filterKey]: {}
			};
		}

		case SET_MENU_FILTERS: {
			let value = action.value;
			if (!hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}

			let filters;
			filters = cloneDeep(state);
			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
				} else {
					filters[action.filterKey] = {};
				}

				filters[action.filterKey][action.filterItemName].value = value;

				if (!hasValue(filters[action.filterKey][action.filterItemName])) {
					delete filters[action.filterKey][action.filterItemName];
				}
			} else {
				filters[action.filterItemName] = value;
			}

			// Page number must be rest to 1.
			filters.currentPage = 1;

			return {
				...state,
				...filters
			};
		}

		default:
			return state;
	}
}

export const refreshFilters = (filterKey, filters) => {
	return {
		type: REFRESH_FILTERS,
		filterKey,
		filters
	};
};

export const setFilters = (key, filter, value) => {
	return {
		type: SET_FILTERS,
		key,
		filter,
		value
	};
};

export function setMenuFilter(filterKey, filterItemName, value) {
	return {
		type: SET_MENU_FILTERS,
		filterKey,
		filterItemName,
		value
	};
}

export function clearFilters(filterKey) {
	return {
		type: CLEAR_FILTERS,
		filterKey
	};
}
